document.addEventListener('DOMContentLoaded', function () {
  // Sync simple option selects to the hidden variant id select (basic fallback logic)
  var variantSelect = document.querySelector('.product__variant-id');
  var optionSelects = document.querySelectorAll('.product__option-select');
  if (variantSelect && optionSelects.length) {
    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        // Basic fallback: without full variant matrix JSON, first variant stays selected.
        // For multi-variant products, connect this to product.js variants data as a next step.
      });
    });
  }
});
